import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/icon/iconfont.css";

import {
    Avatar,
    Badge,
    Button,
    Cascader,
    Checkbox,
    Col,
    ConfigProvider,
    DatePicker,
    Descriptions,
    Drawer,
    Dropdown,
    Empty,
    Form,
    Grid,
    Image,
    Input,
    InputNumber,
    Menu,
    Modal,
    Pagination,
    Popconfirm,
    Popover,
    Radio,
    Row,
    Select,
    Space,
    Spin,
    Switch,
    Table,
    Tabs,
    Tag,
    TimePicker,
    Tooltip,
    Upload,
} from "ant-design-vue";
import MyPagination from "@/components/pms/landlord/Pagination/Pagination.vue";

const app = createApp(App);
app
    .component("MyPagination", MyPagination)
    .use(Radio)
    .use(Badge)
    .use(Tooltip)
    .use(Empty)
    .use(Spin)
    .use(Drawer)
    .use(TimePicker)
    .use(Space)
    .use(Upload)
    .use(InputNumber)
    .use(Grid)
    .use(Row)
    .use(Col)
    .use(Button)
    .use(Dropdown)
    .use(Menu)
    .use(Pagination)
    .use(Cascader)
    .use(Checkbox)
    .use(DatePicker)
    .use(Descriptions)
    .use(Form)
    .use(Avatar)
    .use(Input)
    .use(Select)
    .use(Image)
    .use(Switch)
    .use(Tag)
    .use(Popconfirm)
    .use(Table)
    .use(ConfigProvider)
    .use(Popover)
    .use(Modal)
    .use(Tabs)
    .use(router)
    .mount("#app");
